export const ROLE_LABELS: Record<string, string> = {
  superadmin: 'Администратор платформы',
  org_admin: 'Администратор организации',
  user: 'Пользователь (legacy)',
  analyst: 'Аналитик',
  viewer: 'Наблюдатель (legacy)',
}

export const ROLE_COLORS: Record<string, string> = {
  superadmin: 'red',
  org_admin: 'orange',
  user: 'geekblue',
  analyst: 'blue',
  viewer: 'default',
}

export const ROLE_DESCRIPTIONS: Record<string, string> = {
  superadmin: 'Полный доступ к админ-порталу и ко всем организациям. Назначается только вручную.',
  org_admin: 'Доступ к админ-порталу и управлению сотрудниками только в пределах своей организации.',
  analyst: 'Обычный рабочий пользователь платформы. BI-доступ определяется группами и RLS.',
  viewer: 'Legacy-роль. Новым пользователям больше не назначается.',
  user: 'Legacy-роль. Новым пользователям больше не назначается.',
}

export function getAssignableRoles(isSuperadmin: boolean): string[] {
  if (isSuperadmin) {
    return ['superadmin', 'org_admin', 'analyst']
  }
  return ['analyst']
}
